import useArchive from "@hooks/useArchive"

export default function useSalonVoteArchive(salon: Jury.Models.Salon, participations?: Jury.Resources.Nomination[]) {
    const archive = useArchive(participations)

    archive.usePagination(100, "photos")
    archive.useOptions({ idx: true })
    archive.useGrid({ columns: "4" })
    archive.useEmpty({
        heading: salon.state?.voted ? "All the photos were voted!" : "No photos in this category.",
        description: `Thank you! We appreciate your time and effort.`
    }, [Boolean(salon.state?.voted)])

    return archive
}